<% const settings = organisation && organisation.settings ? organisation.settings : {}; %>
<% const data = organisation && organisation.data ? organisation.data : {}; %>
<% const address = data.address ? data.address : {}; %>

<div class="card">
    <div class="card-body">
        <div class="d-flex align-items-center justify-content-between mb-4">
            <div>
                <h4 class="card-title mb-0">Settings</h4>
            </div>
        </div>

        <ul class="nav nav-pills user-profile-tab border-bottom" id="settingsTabs" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link position-relative rounded-0 active d-flex align-items-center justify-content-center bg-transparent fs-3 py-3"
                        data-type="settings-tab" data-tab-target="#pills-general"
                        type="button" role="tab" aria-controls="pills-general" aria-selected="true">
                    <i class="ti ti-settings me-2 fs-6"></i>
                    <span class="d-none d-md-block">General</span>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link position-relative rounded-0 d-flex align-items-center justify-content-center bg-transparent fs-3 py-3"
                        data-type="settings-tab" data-tab-target="#pills-organisation"
                        type="button" role="tab" aria-controls="pills-organisation" aria-selected="false">
                    <i class="ti ti-building me-2 fs-6"></i>
                    <span class="d-none d-md-block">Organisation</span>
                </button>
            </li>
        </ul>

        <div class="tab-content pt-4" id="settingsTabContent">
            <!-- General Settings Tab -->
            <div class="tab-pane fade show active" id="pills-general" role="tabpanel" aria-labelledby="pills-general-tab" tabindex="0">
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <h5 class="mb-0">General Settings</h5>
                    <button type="button" class="btn btn-primary" data-type="edit-general-settings">
                        <i class="ti ti-pencil me-1"></i>Edit
                    </button>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">Document Retention</label>
                            <p class="mb-0 fs-4 fw-medium"><%= (settings.documentRetentionDays != null ? settings.documentRetentionDays : 30) + ' days' %></p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">Default Currency</label>
                            <p class="mb-0 fs-4 fw-medium"><%= settings.defaultCurrency || 'USD' %></p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">Default Timezone</label>
                            <p class="mb-0 fs-4 fw-medium"><%= settings.defaultTimezone || 'UTC' %></p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Organisation Tab -->
            <div class="tab-pane fade" id="pills-organisation" role="tabpanel" aria-labelledby="pills-organisation-tab" tabindex="0">
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <h5 class="mb-0">Organisation Details</h5>
                    <button type="button" class="btn btn-primary" data-type="edit-organisation">
                        <i class="ti ti-pencil me-1"></i>Edit
                    </button>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">Organisation Name</label>
                            <p class="mb-0 fs-4 fw-medium"><%= organisation ? organisation.name || '---' : '---' %></p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">Organisation ID</label>
                            <p class="mb-0 fs-4 fw-medium"><pre><%= organisation ? organisation.id : '---' %></pre></p>
                        </div>
                    </div>
                </div>

                <h6 class="text-muted border-top pt-3 mt-3">Address</h6>
                <div class="row">
                    <div class="col-md-12">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">Street</label>
                            <p class="mb-0 fs-4 fw-medium"><%= address.street || '---' %></p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">City</label>
                            <p class="mb-0 fs-4 fw-medium"><%= address.city || '---' %></p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">State / Region</label>
                            <p class="mb-0 fs-4 fw-medium"><%= address.state || '---' %></p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">Postal Code</label>
                            <p class="mb-0 fs-4 fw-medium"><%= address.postalCode || '---' %></p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">Country</label>
                            <p class="mb-0 fs-4 fw-medium"><%= address.country || '---' %></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section class="border-top pt-4 mt-3" aria-labelledby="dpa-title">
            <h5 id="dpa-title">Data Processing Agreement</h5>
            <p>
                Where we process personal data in your templates, template data and generated documents on your behalf,
                our Data Processing Agreement applies.
                <a href="https://www.tmplvision.io/legal/dpa" target="_blank" rel="noopener">Read the DPA</a>
                &middot;
                <a href="https://www.tmplvision.io/assets/legal/tmplvision-dpa-v<%= dpa ? dpa.currentVersion : '1.0' %>.pdf" target="_blank" rel="noopener">Download PDF</a>
            </p>
            <% if (dpa) { %>
                <p class="mb-3" data-id="dpa-status">
                    <% if (dpa.isAccepted) { %>
                        <i class="ti ti-circle-check text-success me-1"></i>
                        Accepted version <%= dpa.acceptedVersion %> on <%= new Date(dpa.acceptedAt).toISOString().slice(0, 16).replace('T', ' ') %> UTC<% if (dpa.acceptedByName) { %> by <%= dpa.acceptedByName %><% } %>
                    <% } else if (dpa.acceptedVersion) { %>
                        Not accepted yet (new version <%= dpa.currentVersion %>)
                    <% } else { %>
                        Not accepted yet
                    <% } %>
                </p>
                <% if (!dpa.isAccepted && dpa.canAccept) { %>
                    <button type="button" class="btn btn-outline-primary" data-type="accept-dpa">Accept DPA</button>
                <% } %>
            <% } else { %>
                <p class="mb-0 text-muted">The acceptance status could not be loaded.</p>
            <% } %>
        </section>
        <% if (data.acquisition && data.acquisition.consentedAt) { %>
        <section class="border-top pt-4 mt-3" aria-labelledby="campaign-measurement-title">
            <h5 id="campaign-measurement-title">Previous campaign data</h5>
                <p>Account-linked campaign measurement has ended. You can view or remove data stored with your earlier permission.</p>
                <details class="mb-3">
                    <summary>View stored measurement data</summary>
                    <dl class="mt-2 mb-0">
                        <dt>Campaign</dt><dd><%= data.acquisition.campaign %></dd>
                        <dt>Consent given (UTC)</dt><dd><%= data.acquisition.consentedAt %></dd>
                        <dt>First successful document (UTC)</dt><dd><%= data.acquisition.firstSuccessAt || 'Not recorded' %></dd>
                        <dt>First successful document from a non-demo upload (UTC)</dt><dd><%= data.acquisition.firstUploadedSuccessAt || 'Not recorded' %></dd>
                        <dt>First successful API document (UTC)</dt><dd><%= data.acquisition.firstApiSuccessAt || 'Not recorded' %></dd>
                    </dl>
                </details>
                <button type="button" class="btn btn-outline-secondary" data-type="withdraw-acquisition">Remove previous campaign data</button>
        </section>
        <% } %>
    </div>
</div>

<!-- Edit General Settings Modal -->
<div class="modal fade" id="editGeneralSettingsModal" tabindex="-1" aria-labelledby="editGeneralSettingsModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editGeneralSettingsModalLabel">Edit General Settings</h5>
                <button type="button" class="btn-close" data-type="general-modal-close" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form id="edit-general-settings-form">
                    <div class="mb-3">
                        <label class="form-label">Document Retention (days)</label>
                        <input type="number"
                               class="form-control"
                               id="edit-document-retention"
                               name="documentRetentionDays"
                               value="<%= settings.documentRetentionDays != null ? settings.documentRetentionDays : 30 %>"
                               min="1"
                               max="365">
                        <div class="form-text">How long generated documents are kept before automatic deletion.</div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Default Currency</label>
                        <select class="form-select" id="edit-default-currency" name="defaultCurrency">
                            <option value="USD" <%= settings.defaultCurrency === 'USD' ? 'selected' : '' %>>USD - US Dollar</option>
                            <option value="EUR" <%= settings.defaultCurrency === 'EUR' ? 'selected' : '' %>>EUR - Euro</option>
                            <option value="GBP" <%= settings.defaultCurrency === 'GBP' ? 'selected' : '' %>>GBP - British Pound</option>
                            <option value="CHF" <%= settings.defaultCurrency === 'CHF' ? 'selected' : '' %>>CHF - Swiss Franc</option>
                            <option value="JPY" <%= settings.defaultCurrency === 'JPY' ? 'selected' : '' %>>JPY - Japanese Yen</option>
                            <option value="CAD" <%= settings.defaultCurrency === 'CAD' ? 'selected' : '' %>>CAD - Canadian Dollar</option>
                            <option value="AUD" <%= settings.defaultCurrency === 'AUD' ? 'selected' : '' %>>AUD - Australian Dollar</option>
                        </select>
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Default Timezone</label>
                        <select class="form-select" id="edit-default-timezone" name="defaultTimezone">
                            <option value="UTC" <%= settings.defaultTimezone === 'UTC' ? 'selected' : '' %>>UTC</option>
                            <option value="America/New_York" <%= settings.defaultTimezone === 'America/New_York' ? 'selected' : '' %>>America/New_York (EST/EDT)</option>
                            <option value="America/Los_Angeles" <%= settings.defaultTimezone === 'America/Los_Angeles' ? 'selected' : '' %>>America/Los_Angeles (PST/PDT)</option>
                            <option value="America/Chicago" <%= settings.defaultTimezone === 'America/Chicago' ? 'selected' : '' %>>America/Chicago (CST/CDT)</option>
                            <option value="Europe/London" <%= settings.defaultTimezone === 'Europe/London' ? 'selected' : '' %>>Europe/London (GMT/BST)</option>
                            <option value="Europe/Berlin" <%= settings.defaultTimezone === 'Europe/Berlin' ? 'selected' : '' %>>Europe/Berlin (CET/CEST)</option>
                            <option value="Europe/Paris" <%= settings.defaultTimezone === 'Europe/Paris' ? 'selected' : '' %>>Europe/Paris (CET/CEST)</option>
                            <option value="Europe/Zurich" <%= settings.defaultTimezone === 'Europe/Zurich' ? 'selected' : '' %>>Europe/Zurich (CET/CEST)</option>
                            <option value="Asia/Tokyo" <%= settings.defaultTimezone === 'Asia/Tokyo' ? 'selected' : '' %>>Asia/Tokyo (JST)</option>
                            <option value="Asia/Singapore" <%= settings.defaultTimezone === 'Asia/Singapore' ? 'selected' : '' %>>Asia/Singapore (SGT)</option>
                            <option value="Australia/Sydney" <%= settings.defaultTimezone === 'Australia/Sydney' ? 'selected' : '' %>>Australia/Sydney (AEST/AEDT)</option>
                        </select>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-type="general-modal-cancel">Cancel</button>
                <button type="button" class="btn btn-primary" data-type="general-modal-save">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Edit Organisation Modal -->
<div class="modal fade" id="editOrganisationModal" tabindex="-1" aria-labelledby="editOrganisationModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editOrganisationModalLabel">Edit Organisation</h5>
                <button type="button" class="btn-close" data-type="organisation-modal-close" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form id="edit-organisation-form">
                    <div class="mb-3">
                        <label class="form-label">Organisation Name <span class="text-danger">*</span></label>
                        <input type="text"
                               class="form-control"
                               id="edit-organisation-name"
                               name="name"
                               value="<%= organisation ? organisation.name || '' : '' %>"
                               placeholder="Enter organisation name"
                               required>
                    </div>

                    <h6 class="text-muted border-top pt-3 mt-3 mb-3">Address</h6>

                    <div class="mb-3">
                        <label class="form-label">Street</label>
                        <input type="text"
                               class="form-control"
                               id="edit-organisation-street"
                               name="street"
                               value="<%= address.street || '' %>"
                               placeholder="Enter street address">
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">City</label>
                                <input type="text"
                                       class="form-control"
                                       id="edit-organisation-city"
                                       name="city"
                                       value="<%= address.city || '' %>"
                                       placeholder="Enter city">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">State / Region</label>
                                <input type="text"
                                       class="form-control"
                                       id="edit-organisation-state"
                                       name="state"
                                       value="<%= address.state || '' %>"
                                       placeholder="Enter state or region">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Postal Code</label>
                                <input type="text"
                                       class="form-control"
                                       id="edit-organisation-postal"
                                       name="postalCode"
                                       value="<%= address.postalCode || '' %>"
                                       placeholder="Enter postal code">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Country</label>
                                <input type="text"
                                       class="form-control"
                                       id="edit-organisation-country"
                                       name="country"
                                       value="<%= address.country || '' %>"
                                       placeholder="Enter country">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-type="organisation-modal-cancel">Cancel</button>
                <button type="button" class="btn btn-primary" data-type="organisation-modal-save">Save</button>
            </div>
        </div>
    </div>
</div>

